import React from 'react';
import { Box, Typography } from '@saviynt/design-system';

import { useInvertedLocalize } from '../../../../shared/hooks';

/**
 * MyReport
 */
function MyReport() {
  const l = useInvertedLocalize();

  return (
    <Box className='ReportModal-MyReport'>
      <Typography kind='h3'>{l('No Personalized Report Yet')}</Typography>
      <Typography kind='body2'>
        {l('You can save a report during preview.')}
      </Typography>
    </Box>
  );
}

export default MyReport;
